module.exports = __webpack_public_path__ + "img/30.887e3fd4.png";